export const Actions = {
  REGISTER_SUCCESS: "REGISTER_SUCCESS",
  REGISTER_FAIL: "REGISTER_FAIL",
  LOGIN_START: "LOGIN_START",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAIL: "LOGIN_FAIL",
  REFRESH_START: "REFRESH_START",
  REFRESH_SUCCESS: "REFRESH_SUCCESS",
  REFRESH_FAIL: "REFRESH_FAIL",
  UPDATE_START: "UPDATE_START",
  UPDATE_SUCCESS: "UPDATE_SUCCESS",
  UPDATE_FAILURE: "UPDATE_FAILURE",
  LOGOUT: "LOGOUT",
  SET_MESSAGE: "SET_MESSAGE",
  CLEAR_MESSAGE: "CLEAR_MESSAGE",
  GET_CATS: "GET_CATS",
  CART_LOADING: "CART_LOADING",
  CART_SET: "CART_SET",
  CART_ERROR: "CART_ERROR",
  CART_CLEAR: "CART_CLEAR",
  CART_CHECKOUT_SUCCESS: "CART_CHECKOUT_SUCCESS",
};
